// Share of a voxel count in percent; 0 when there is nothing to share.
export function voxelPercent(count: number, total: number): number {
    return total > 0 ? (100 * count) / total : 0;
}
